import { render, staticRenderFns } from "./EventsListPage.vue?vue&type=template&id=f4638a68&scoped=true"
import script from "./EventsListPage.vue?vue&type=script&lang=ts"
export * from "./EventsListPage.vue?vue&type=script&lang=ts"
import style0 from "./EventsListPage.vue?vue&type=style&index=0&id=f4638a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4638a68",
  null
  
)

export default component.exports